module.exports = "<modal #modal>\r\n    <modal-header [show-close]=\"true\">\r\n        <h5 style=\"color: #fff;margin-top: 3px;\r\n        font-weight: 700;\" class=\"modal-title\">{{setting.caption}}</h5>\r\n    </modal-header>\r\n    <modal-body>\r\n        <h4>{{setting.message}}</h4>\r\n    </modal-body>\r\n    <modal-footer>\r\n        <input type=\"button\" class=\"btn btn-grid btn-btnsize\" (click)=\"yes();\" value=\"Yes\">\r\n        <input type=\"button\" class=\"btn btn-grid btn-btnsize\" (click)=\"no();\" value=\"No\">\r\n    </modal-footer>\r\n</modal>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/messagebox/messagebox.component.html
// module id = 1058
// module chunks = 22